import { useCallback, useEffect, useState } from 'react';

// 의뢰자 정보 폼 공통 — 데스크톱(RequesterInfo)·모바일(RequesterInfoM)이 같은 상태·동작을 쓴다
export const REQUESTER_FIELDS = [
  { name: 'company', placeholder: '상호', autoComplete: 'organization' },
  { name: 'dept', placeholder: '부서명', autoComplete: 'organization-title' },
  { name: 'name', placeholder: '담당자명', autoComplete: 'name' },
  { name: 'tel', placeholder: '연락처', autoComplete: 'tel', inputMode: 'tel' },
];

export function useRequesterForm(cmStore, loginStore) {
  const { requester, setRequester, setRequesterAddress, prefillRequester } = cmStore;
  const { userInfo } = loginStore;
  const [addrOpen, setAddrOpen] = useState(false);

  // 로그인 회원이면 상호·담당자·연락처 빈 칸을 회원 정보로 채운다
  useEffect(() => {
    if (userInfo) prefillRequester(userInfo);
  }, [userInfo, prefillRequester]);

  const handleChange = useCallback((e) => {
    setRequester(e.target.name, e.target.value);
  }, [setRequester]);

  const openAddress = useCallback(() => setAddrOpen(true), []);
  const closeAddress = useCallback(() => setAddrOpen(false), []);
  const selectAddress = useCallback((selection) => {
    setRequesterAddress(selection.address, selection.bcode);
  }, [setRequesterAddress]);

  return { requester, handleChange, addrOpen, openAddress, closeAddress, selectAddress };
}
